import { ConfigApi, IdentityApi } from '@backstage/core-plugin-api';
import { AppConfigApi } from './appconfig-api';
import {
  AppConfigConfiguration,
  AppConfigProfile,
  AppConfigProfilesResponse,
} from '../types/types';

export class AppConfigApiClient implements AppConfigApi {
  private readonly configApi: ConfigApi;
  private readonly identityApi: IdentityApi;

  constructor(configApi: ConfigApi, identityApi: IdentityApi) {
    this.configApi = configApi;
    this.identityApi = identityApi;
  }

  private async fetchJson<T>(path: string): Promise<T> {
    const { token } = await this.identityApi.getCredentials();
    const baseUrl = this.configApi.getString('backend.baseUrl');

    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
    };
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    const response = await fetch(`${baseUrl}${path}`, { headers });

    if (!response.ok) {
      throw new Error(
        `AppConfig API error: ${response.status} ${response.statusText}`,
      );
    }

    return response.json();
  }

  async getProfiles(
    accountId: string,
    region?: string,
  ): Promise<AppConfigProfile[]> {
    const params = new URLSearchParams({ accountId });
    if (region) {
      params.set('region', region);
    }
    const { profiles } = await this.fetchJson<AppConfigProfilesResponse>(
      `/api/appconfig/profiles?${params}`,
    );
    return profiles;
  }

  async getConfiguration(
    accountId: string,
    applicationId: string,
    environmentId: string,
    profileId: string,
    region?: string,
  ): Promise<AppConfigConfiguration> {
    const params = new URLSearchParams({
      accountId,
      applicationId,
      environmentId,
      profileId,
      ...(region ? { region } : {}),
    });
    return this.fetchJson(`/api/appconfig/configuration?${params}`);
  }
}
